"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '1em',
      display: 'block'
    },
    className: "card card-body card-text"
  }, /*#__PURE__*/_react["default"].createElement(_question["default"], {
    spaceRight: true,
    inline: true
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: '300'
    }
  }, props.text));
};